import { useContext, useRef } from 'react';
import {
  getOrganizationFlag,
  getUserAuthFlag,
  OrganizationFeatureFlag,
  UserAuthFeatureFlag,
  UserAuthFlagEnum,
  UserAuthTmpFeatureConfigFlagEnum,
  UserAuthTmpFeatureConfigFlag,
  getTmpFeatureConfigFlag,
} from '../features/FeatureFlag';
import { GlobalConfigurationContext } from '../context/GlobalConfigurationContext';
import { isVendorMode } from '../Vendor';

const useFeatureFlag = (
  featureFlag:
    | OrganizationFeatureFlag
    | UserAuthFeatureFlag
    | UserAuthTmpFeatureConfigFlag,
  onlyForMT?: boolean
): boolean => {
  const { userAuth } = useContext(GlobalConfigurationContext);

  const { current: flagValue } = useRef(
    (() => {
      const userAuthFlag = featureFlag as UserAuthFeatureFlag;
      if (Object.values(UserAuthFlagEnum).includes(userAuthFlag) && userAuth) {
        return getUserAuthFlag(featureFlag as UserAuthFeatureFlag, userAuth);
      }

      const tmpFeatureConfigFlag = featureFlag as UserAuthTmpFeatureConfigFlag;
      if (
        Object.values(UserAuthTmpFeatureConfigFlagEnum).includes(
          tmpFeatureConfigFlag
        ) &&
        userAuth
      ) {
        return getTmpFeatureConfigFlag(tmpFeatureConfigFlag, userAuth);
      }

      const organizationAuthFlag = featureFlag as OrganizationFeatureFlag;
      return getOrganizationFlag(organizationAuthFlag);
    })()
  );

  if (onlyForMT === true) {
    return flagValue && isVendorMode();
  }

  return flagValue;
};

export default useFeatureFlag;
